import * as types from '../constants/ActionTypes'
import axios from "axios";
import category from '../components/category';

// Url's
// const getFilterItems = `${process.env.REACT_APP_API_URL}api/csa-app`;
const getFilterItems = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog`;



// Filters
// All
export const filterAllSuccess = (allFilters) => ({
  type: types.FILTER_ALL_SUCCESS,
  allFilters
});
export const filterAllRequested = () => ({
  type: types.FILTER_ALL_REQUEST
});

export const filterAllFailure = error => ({
  type: types.FILTER_ALL_FAILURE,
  error
});

// Brand
export const filterBrandSuccess = (brands) => ({
    type: types.FILTER_BRAND_SUCCESS,
    brands
});
export const filterBrandRequested = () => ({
    type: types.FILTER_BRAND_REQUEST
});

export const filterBrandFailure = error => ({
    type: types.FILTER_BRAND_FAILURE,
    error
});

//Color
export const filterColorSuccess = (colors) => ({
  type: types.FILTER_COLOUR_SUCCESS,
  colors
});
export const filterColorRequested = () => ({
  type: types.FILTER_COLOUR_REQUEST
});

export const filterColorFailure = error => ({
  type: types.FILTER_COLOUR_FAILURE,
  error
});

//Range
export const filterRangeSuccess = (range) => ({
  type: types.FILTER_RANGE_SUCCESS,
  range
});
export const filterRangeRequested = () => ({
  type: types.FILTER_RANGE_REQUEST
});

export const filterRangeFailure = error => ({
  type: types.FILTER_RANGE_FAILURE,
  error
});

//Gender
export const filterGenderSuccess = (genders) => ({
  type: types.FILTER_GENDER_SUCCESS,
  genders
});
export const filterGenderRequested = () => ({
  type: types.FILTER_GENDER_REQUEST
});

export const filterGenderFailure = error => ({
  type: types.FILTER_GENDER_FAILURE,
  error
});

// Reset Filter
export const resetFilterSuccess= () => ({
  type: types.FILTER_RESET_SUCCESS
});

// seach filters selected

export const setFilters= (selected) => ({
  type: types.FILTER_SET,
  selected
});


// API
export const getAllFilters = (options) => {
  return dispatch => {
    dispatch(filterAllRequested());
    // axios.get(getFilterItems + '/category-filter', {

    //   params: {
    //     connection_id,
    //     category_id,
    //    main_category_id,
    //    main_category_level,
    //     gender_id
    //   },
    // })
    
     axios.get(getFilterItems + '/category-filter', 
       { params : {
         category_id: options.category_id,
         brand_code : options.brand_code,
       category_level_1: options.category_level_1 === null ? null : options.category_level_1+'',
       category_level_2: options.category_level_2 === null ? null : options.category_level_2+'',
       category_level_3: options.category_level_3=== null ? null : options.category_level_3+'',
       category_level_4: options.category_level_4 === null ? null : options.category_level_4+'',
       category_level_5: options.category_level_5 === null ? null : options.category_level_5+'',
       connection_id: options.connection_id,
       gender_id: JSON.stringify(options.gender_id)},
     }
     )
    // axios.post(getFilterItems + '/category-filter', 
    //   {
    //     category_id: options.category_id,
    //     brand_code : options.brand_code,
    //   category_level_1: options.category_level_1 === null ? null : options.category_level_1+'',
    //   category_level_2: options.category_level_2 === null ? null : options.category_level_2+'',
    //   category_level_3: options.category_level_3=== null ? null : options.category_level_3+'',
    //   category_level_4: options.category_level_4 === null ? null : options.category_level_4+'',
    //   category_level_5: options.category_level_5 === null ? null : options.category_level_5+'',
    //   connection_id: options.connection_id,
    //   gender_id: options.gender_id}
    // , {
    //     headers: {
    //       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    //       //'Content-Type': 'application/json; charset=UTF-8'
    //     },
    //   })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(filterAllSuccess(res.data.results.category_filter_data));
        } else if (res.data.ack === "Failure") {
          dispatch(filterAllFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};


export const setSearchFilters = (selectedFilters) => {
  return dispatch => {
    dispatch(setFilters(selectedFilters));
  };
};

export const getBrandFilters = (connection_id) => {
    return dispatch => {
      dispatch(filterBrandRequested());
      axios.get(getFilterItems + '/get-brand-list', {
        params: {
          connection_id
        },
      })
        .then(res => {
          if (res.data.ack === "Success") {
            dispatch(filterBrandSuccess(res.data.results.brand));
          } else if (res.data.ack === "Failure") {
            dispatch(filterBrandFailure(res.data.status));
          } 
        })
        .catch(err => {
            throw err;
          // dispatch(addTodoFailure(err.message));
        });
    };
  };
  
  export const getColourFilters = (connection_id) => {
    return dispatch => {
      dispatch(filterBrandRequested());
      axios.get(getFilterItems + '/get-color-list', {
        params: {
          connection_id,
          brand_code:'Mango'
        },
      })
        .then(res => {
          if (res.data.ack === "Success") {
            dispatch(filterBrandSuccess(res.data.results.color));
          } else if (res.data.ack === "Failure") {
            dispatch(filterBrandFailure(res.data.status));
          } 
        })
        .catch(err => {
            throw err;
          // dispatch(addTodoFailure(err.message));
        });
    };
  };

  export const getGenderFilters = (connection_id) => {
    return dispatch => {
      dispatch(filterGenderRequested());
      axios.get(getFilterItems + '/get-gender-list', {
        params: {
          connection_id
        },
      })
        .then(res => {
          if (res.data.ack === "Success") {
            dispatch(filterGenderSuccess(res.data.results.gender));
          } else if (res.data.ack === "Failure") {
            dispatch(filterGenderFailure(res.data.status));
          } 
        })
        .catch(err => {
            throw err;
          // dispatch(addTodoFailure(err.message));
        });
    };
  };

  export const getRangeFilters = ({connection_id, brand_code, category_id}) => {
    return dispatch => {
      dispatch(filterRangeRequested());
      axios.get(getFilterItems + '/get-price-range', {
        params: {
          connection_id,
          brand_code,
          category_id
        },
      })
        .then(res => {
          if (res.data.ack === "Success") {
            dispatch(filterRangeSuccess(res.data.results.price_range));
          } else if (res.data.ack === "Failure") {
            dispatch(filterRangeFailure(res.data.status));
          } 
        })
        .catch(err => {
            throw err;
          // dispatch(addTodoFailure(err.message));
        });
    };
  };

  export const restFilters = () => {
    return dispatch => {
      dispatch(resetFilterSuccess());
    };
  };